import { render, staticRenderFns } from "./MateriasEsterilizados.vue?vue&type=template&id=20d83013&scoped=true&"
import script from "./MateriasEsterilizados.vue?vue&type=script&lang=js&"
export * from "./MateriasEsterilizados.vue?vue&type=script&lang=js&"
import style0 from "./MateriasEsterilizados.vue?vue&type=style&index=0&id=20d83013&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20d83013",
  null
  
)

export default component.exports